// -----------------------------会员-------------------------------
export const ON_RECHARGE_SUCCESS = 'ON_RECHARGE_SUCCESS'
export const ON_RECHARGE_ERROR = 'ON_RECHARGE_ERROR'

export const DO_RECHARGE = 'DO_RECHARGE'
export const DO_CREATE_VIP = 'DO_CREATE_VIP'

export const DO_GET_ALL_USERS = 'DO_GET_ALL_USERS'
export const ON_GET_ALL_USERS = 'ON_GET_ALL_USERS'

export const ON_GET_USER_SEARCH = 'ON_GET_USER_SEARCH'
export const DO_GET_USER_SEARCH = 'DO_GET_USER_SEARCH'

export const DO_GET_USER_LIST = 'DO_GET_USER_LIST'
export const ON_GET_USER_LIST = 'ON_GET_USER_LIST'

export const ON_USER_VIEW = 'ON_USER_VIEW'
export const DO_USER_VIEW = 'DO_USER_VIEW'

export const DO_GET_USER_PROFILE = 'DO_GET_USER_PROFILE'
export const ON_GET_USER_PROFILE = 'DO_ON_USER_PROFILE'

export const DO_UPDATE_USER_PROFILE = 'DO_UPDATE_USER_PROFILE'
export const ON_UPDATE_USER_PROFILE = 'ON_UPDATE_USER_PROFILE'
// -----------------------------洗衣单------------------------------
export const DO_GET_TICKET_LIST = 'DO_GET_TICKET_LIST'
export const ON_GET_TICKET_LIST = 'ON_GET_TICKET_LIST'

export const ON_PAY_TICKET_SUCCESS = 'ON_PAY_TICKET_SUCCESS'
export const ON_PAY_TICKET_ERROR = 'ON_PAY_TICKET_ERROR'

export const ON_CREATE_TICKET_SUCCESS = 'ON_CREATE_TICKET_SUCCESS'
export const ON_CREATE_TICKET_ERROR = 'ON_CREATE_TICKET_ERROR'

export const DO_CREATE_TICKET = 'DO_CREATE_TICKET'
export const DO_PAY_TICKET = 'DO_PAY_TICKET'
export const DO_PAY_CLOTHE = 'DO_PAY_CLOTHE'
export const DO_TAKE_OFF_TICKET = 'DO_TAKE_OFF_TICKET'
export const DO_TAKE_OFF_CLOTHE = 'DO_TAKE_OFF_CLOTHE'

// ----------------------------常量---------------------------------
export const DO_GET_ALL_BRANDS = 'DO_GET_ALL_BRANDS'
export const DO_GET_HOT_BRANDS = 'DO_GET_HOT_BRANDS'
export const ON_GET_ALL_BRANDS = 'ON_GET_ALL_BRANDS'
export const ON_GET_HOT_BRANDS = 'ON_GET_HOT_BRANDS'

export const DO_GET_BRANDS_SELECTOR_HEADERS = 'DO_GET_BRANDS_SELECTOR_HEADERS'
export const DO_GET_BRANDS_BY_SEARCH_SELECTOR_HEADER = 'DO_GET_BRANDS_BY_SEARCH_SELECTOR_HEADER'

export const ON_GET_BRANDS_SELECTOR_HEADERS = 'ON_GET_BRANDS_SELECTOR_HEADERS'
export const ON_GET_BRANDS_BY_SEARCH_SELECTOR_HEADER = 'ON_GET_BRANDS_BY_SEARCH_SELECTOR_HEADER'

export const DO_GET_ALL_COLORS = 'DO_GET_ALL_COLORS'
export const DO_GET_HOT_COLORS = 'DO_GET_HOT_COLORS'
export const ON_GET_ALL_COLORS = 'ON_GET_ALL_COLORS'
export const ON_GET_HOT_COLORS = 'ON_GET_HOT_COLORS'

export const DO_GET_COLORS_SELECTOR_HEADERS = 'DO_GET_COLORS_SELECTOR_HEADERS'
export const DO_GET_COLORS_BY_SEARCH_SELECTOR_HEADER = 'DO_GET_COLORS_BY_SEARCH_SELECTOR_HEADER'

export const ON_GET_COLORS_SELECTOR_HEADERS = 'ON_GET_COLORS_SELECTOR_HEADERS'
export const ON_GET_COLORS_BY_SEARCH_SELECTOR_HEADER = 'ON_GET_COLORS_BY_SEARCH_SELECTOR_HEADER'

export const DO_GET_ALL_FLAWS = 'DO_GET_ALL_FLAWS'
export const DO_GET_HOT_FLAWS = 'DO_GET_HOT_FLAWS'
export const ON_GET_ALL_FLAWS = 'ON_GET_ALL_FLAWS'
export const ON_GET_HOT_FLAWS = 'ON_GET_HOT_FLAWS'
export const RESET_FLAWS_SELECTOR = 'RESET_FLAWS_SELECTOR'

export const DO_GET_FLAWS_SELECTOR_HEADERS = 'DO_GET_FLAWS_SELECTOR_HEADERS'
export const DO_GET_FLAWS_BY_SEARCH_SELECTOR_HEADER = 'DO_GET_FLAWS_BY_SEARCH_SELECTOR_HEADER'

export const ON_GET_FLAWS_SELECTOR_HEADERS = 'ON_GET_FLAWS_SELECTOR_HEADERS'
export const ON_GET_FLAWS_BY_SEARCH_SELECTOR_HEADER = 'ON_GET_FLAWS_BY_SEARCH_SELECTOR_HEADER'

export const DO_GET_ALL_PRICES = 'DO_GET_ALL_PRICES'
export const DO_GET_HOT_PRICES = 'DO_GET_HOT_PRICES'
export const ON_GET_ALL_PRICES = 'ON_GET_ALL_PRICES'
export const ON_GET_HOT_PRICES = 'ON_GET_HOT_PRICES'

export const DO_GET_PRICES_SELECTOR_HEADERS = 'DO_GET_PRICES_SELECTOR_HEADERS'
export const DO_GET_PRICES_BY_SEARCH_SELECTOR_HEADER = 'DO_GET_PRICES_BY_SEARCH_SELECTOR_HEADER'

export const ON_GET_PRICES_SELECTOR_HEADERS = 'ON_GET_PRICES_SELECTOR_HEADERS'
export const ON_GET_PRICES_BY_SEARCH_SELECTOR_HEADER = 'ON_GET_PRICES_BY_SEARCH_SELECTOR_HEADER'

export const ON_GET_TICKET = 'ON_GET_TICKET'
export const DO_GET_TICKET = 'DO_GET_TICKET'

export const SET_CREATE_TICKET_STATE = 'SET_CREATE_TICKET_STATE'

export const DO_ADD_CLOTHE_RECORD_TO_TICKET = 'DO_ADD_CLOTHE_RECORD_TO_TICKET'
export const DO_REMOVE_CLOTHE_RECORD_FROM_TICKET = 'DO_REMOVE_CLOTHE_RECORD_FROM_TICKET'
export const RESET_CLOTHE_RECORDS = 'RESET_CLOTHE_RECORDS'

export const DO_GET_ACCOUNT_RECORD = 'DO_GET_ACCOUNT_RECORD'
export const ON_GET_ACCOUNT_RECORD = 'ON_GET_ACCOUNT_RECORD'
export const DO_GET_ACCOUNT_RECORD_LIST = 'DO_GET_ACCOUNT_RECORD_LIST'
export const ON_GET_ACCOUNT_RECORD_LIST = 'ON_GET_ACCOUNT_RECORD_LIST'

export const DO_LOGIN = 'DO_LOGIN'
export const ON_LOGIN = 'ON_LOGIN'

export const DO_GET_NOTIFICATIONS = 'DO_GET_NOTIFICATIONS'
export const ON_GET_NOTIFICATIONS = 'ON_GET_NOTIFICATIONS'
export const DO_READ_NOTIFICATION = 'DO_READ_NOTIFICATION'

export const DO_GET_CLOHTE = 'DO_GET_CLOHTE'
export const ON_GET_CLOTHE = 'ON_GET_CLOTHE'

export const DO_ADD_CLOTHE_PRICE = 'DO_ADD_CLOTHE_PRICE'
export const DO_ADD_BRAND = 'DO_ADD_BRAND'
export const DO_ADD_COLOR = 'DO_ADD_COLOR'
export const DO_ADD_FLAW = 'DO_ADD_FLAW'

export const DO_GET_VERSIONS = 'DO_GET_VERSIONS'
export const DO_CREATE_VERSION = 'DO_CREATE_VERSION'
export const DO_UPDATE_VERSION = 'DO_UPDATE_VERSION'
export const DO_DELETE_VERSION = 'DO_DELETE_VERSION'

export const ORDER_BRANDS = 'ORDER_BRANDS'
export const ORDER_COLORS = 'ORDER_COLORS'
export const ORDER_FLAWS = 'ORDER_FLAWS'
export const ORDER_PRICES = 'ORDER_PRICES'



// WEBPACK FOOTER //
// ./src/store/types.js